export const ADD_MEDIA = 'ADD_MEDIA';
export const ADD_MEDIAS = 'ADD_MEDIAS';

export function fetchMedia(page) {
  return (dispatch) => {
    return fetch(document.getElementById('wp_mapbox_gl_js_wordpress_url').value+'/index.php/wp-json/wp/v2/media?page='+page+'&per_page=100',{
      method: 'GET'
    })
    .then(response => response.json())
    .then(json => {
      console.log(json);
      var icons = {
        uploaded:[],
        defaults:[],
        maki:[],
        mapkey:[]
      }
      json.forEach(function(media) {
        if(media.meta.wp_mapbox_gl_js_media && media.meta.wp_mapbox_gl_js_media[0]==='uploaded') {
          icons.uploaded.push(media);
        }
        if(media.meta.wp_mapbox_gl_js_media && media.meta.wp_mapbox_gl_js_media[0]==='defaults') {
          icons.defaults.push(media);
        }
        if(media.meta.wp_mapbox_gl_js_media && media.meta.wp_mapbox_gl_js_media[0]==='maki') {
          icons.maki.push(media);
        }
        if(media.meta.wp_mapbox_gl_js_media && media.meta.wp_mapbox_gl_js_media[0]==='mapkey') {
          icons.mapkey.push(media);
        }
      })
      console.log(icons);
      dispatch(addMedias(icons))
    })
    .catch(error => console.log(error.message));
  }
}

export function createMedia(formData, type) {
  return (dispatch) => {
    let header = new Headers({"X-WP-Nonce":window.params.nonce});
    return fetch(document.getElementById('wp_mapbox_gl_js_wordpress_url').value+'/wp-json/wp/v2/media',{
      method: 'POST',
      credentials: 'same-origin',
      headers : header,
      body : formData
    })
    .then(response => response.json())
    .then(json => {
      // Update the meta
      var data = {
        'meta' : {
          'wp_mapbox_gl_js_media' : type
        }
      }
      let header = new Headers({"Content-Type":"application/json","X-WP-Nonce":window.params.nonce});
      fetch(document.getElementById('wp_mapbox_gl_js_wordpress_url').value+'/wp-json/wp/v2/media/'+json.id,{
        method: 'POST',
        credentials: 'same-origin',
        headers : header,
        body : JSON.stringify(data)
      })
      .then(response => response.json())
      .then(jsonUpdated => {
        // Add to list
        console.log(jsonUpdated)
        dispatch(addMedia(jsonUpdated))
      })
      .catch(error => console.log(error));
    })
    .catch(error => console.log(error));
  }
}

export function addMedias(medias) {
  return {
    type : ADD_MEDIAS,
    payload : medias
  }
}

export function addMedia(media) {
  return {
    type : ADD_MEDIA,
    payload : media
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions_media.js